import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/p/whatif/')({
	component: () => <Navigate to='/p/whatif/scenarios' replace />,
})
